import React, { useState, useEffect } from 'react';
import { Redirect, Link } from 'react-router-dom';

import 'react-accessible-accordion/dist/fancy-example.css';

import { getTokenInfo } from '../../UseToken';
import { reqGET, 
    set_language,
	content_language, } from '../../Utils';

import { language } from './Language';
import parse from 'html-react-parser';

import Loader from '../Loader/Loader';

import {api_crud_route, data_interface, endpoints } from './Config';

export default function View(props) {

    const [dados, set_dados] = useState(data_interface);

    const [isloading, setLoading] = useState(true);
    const [isRedirect, setRedirect] = useState(false);

    const [lang, set_lang] = useState('pt');
    const [, set_lang_id] = useState('1');


     // Para Instanciar todo o Objecto 
    const fetchInfo = async (id) => {
        await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id}`)
            .then(res => set_dados(res.data[0]))
            .catch(() => 404
                //  TODO: ENVIAR PÃ�GINA 404
                //  alert(error)); 
            );
    }

    useEffect(() => {

        if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if(el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }


        if (props.location.state !== undefined) {

            fetchInfo(props.location.state.item['id']).then(() => setLoading(false))
        }
        else {
            setLoading(false);
            setRedirect(true);
        }

    }, [props]);



    return isRedirect ?
        <Redirect to={endpoints.list} replace />
        :
        isloading ?
            
            <Loader />
        
            :
            
            <div id="kt_content" className="content d-flex flex-column flex-column-fluid">
                <main>
                    <div className={`dash-cards-2 header`}>
                        {console.log('DADOS ---------->', dados)}
                        <h2 className="dash-title">{language[lang].testimonials}</h2>
                        <p>{language[lang].home} / {language[lang].testimony}</p>
                    </div>

                    <div className={`dash-cards-2 body`}>
                        <div className="card">
                            <div className="card-body">
                                <div className="div-group">
                                    <span className={"flex-2"}>
                                        <h4>{language[lang].name}</h4>
                                        <p>{dados.content[0].name}</p>
                                    </span>
                                    <span className="flex-2">
                                        <h4>{language[lang].email}</h4>
                                        <p>{dados.content[0].email}</p>
                                    </span>
                                    <span className="flex-2" style={{ display: dados.content[0].address === '' ? 'none' : '' }}>
                                        <h4>{language[lang].address}</h4>
                                        <p>{dados.content[0].address}</p>
                                    </span>
                                    <span className="flex-2">
                                        <h4>{language[lang].table_state}</h4>
                                        <span className={dados.info.status === 'accepted' ? "badge rounded-pill bg-success" : (dados.info.status === 'rejected' ? "badge rounded-pill bg-danger" : "badge rounded-pill bg-light")}>
                                            {dados.info.status === 'accepted' ? language[lang].accepted : dados.info.status === 'rejected' ? language[lang].rejected : language[lang].under_review}
                                        </span>
                                    </span>
                                </div>
                                <div className="div-break"></div>
                                <div className="div-group">
                                    <span className={"flex-2"}>
                                        <h4>{language[lang].testimony}</h4>
                                        <p>{parse(dados.content[0].message)}</p>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={'dash-cards-2 footer'}>
                        <nav className="navbar bottom-navbar navbar-light">
                            <div className="navbar-footer">
                                <ul className="navbar-nav float-left"></ul>
                                <ul className="navbar-nav float-right">
                                    <li className="nav-item">
                                        <Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }} replace>
                                            <img alt='' src={'./img/seta_2.svg'} />
                                            <span>{language[lang].back}</span>
                                        </Link>
                                    </li>

                                </ul>
                            </div>
                        </nav>
                    </div>
                </main>
            </div>
}